module.exports = __webpack_public_path__ + "img/Profil_CS-Litevolumen_Standard-125.725faeb6.jpg";